import {
  useQuery,
  useMutation,
  QueryKey,
  UseQueryOptions,
  UseMutationOptions,
} from 'react-query'
import { AxiosError, AxiosResponse } from 'axios'
import api from 'api'
import { SearchLocation } from 'types'
import { SearchLocationOptions } from './types'

const TIME = 1000 * 60 * 5 // 1 min

const SERVICE_NAME = `SearchLocation`

const QueryKeys = {
  search: `${SERVICE_NAME}#search`,
} as const

const MutationKeys = {
  search: `${SERVICE_NAME}#search`,
} as const

const CONTROLLER_PATH = `/app/spourgiti/admin/search-location`

// GET single
export const getSearchLocation = async ({
  queryKey,
}): Promise<SearchLocation> => {
  const [, id] = queryKey

  const { data }: AxiosResponse<SearchLocation> = await api({
    method: 'get',
    url: `/app/spourgiti/admin/search-location/${id}`,
  })
  return data
}
export const useSearchLocation = <T = SearchLocation>(
  id: number,
  options: UseQueryOptions<T, AxiosError, SearchLocation> = {}
) => {
  return useQuery<SearchLocation>([QueryKeys.search, id], getSearchLocation, {
    staleTime: id ? TIME : 0,
    cacheTime: id ? TIME : 0,
    ...options,
  } as Omit<UseQueryOptions<SearchLocation, AxiosError, SearchLocation, QueryKey>, 'queryKey' | 'queryFn'>)
}

// Search
export const searchLocationByCriteria = async (
  payload: SearchLocationOptions
): Promise<SearchLocation[]> => {
  const { data } = await api({
    method: 'post',
    url: `${CONTROLLER_PATH}/search-by-criteria`,
    data: {
      ...payload,
    },
  })

  return data
}
export const useSearchLocationByCriteria = (
  options: Omit<
    UseMutationOptions<SearchLocation[], AxiosError, SearchLocationOptions>,
    'mutationKey' | 'mutationFn'
  > = {}
) => {
  return useMutation(MutationKeys.search, searchLocationByCriteria, {
    ...options,
  } as Omit<UseMutationOptions<SearchLocation[], AxiosError, SearchLocationOptions>, 'mutationKey' | 'mutationFn'>)
}

const SearchLocationService = {
  getSearchLocation,
  searchLocationByCriteria,
  hooks: {
    useSearchLocation,
    useSearchLocationByCriteria,
  },
  keys: { QueryKeys, MutationKeys },
}

export default SearchLocationService
